import { render } from "./AddTrust.vue?vue&type=template&id=14cdcef8&scoped=true"
import script from "./AddTrust.vue?vue&type=script&lang=js"
export * from "./AddTrust.vue?vue&type=script&lang=js"

import "./AddTrust.vue?vue&type=style&index=0&id=14cdcef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cdcef8"]])

export default __exports__